<template>
  <div class="font-ui text-ui-md text-text-secondary px-11">
    <slot />
  </div>
</template>
